export const defineBooleanAry = [
  {value: 0, label: '否'},
  {value: 1, label: '是'}
]
